// Angular
import { Component, OnInit } from '@angular/core';
// Models
import { Tournament } from '../../models/tournament';
// Services

import { ApiService } from '../../services/api';
import * as lodash from 'lodash';
import { OAuthService } from '../../services/o-auth';
import { Club } from '../../models/club'
import { AngularFireDatabase } from 'angularfire2/database';

@Component({
  templateUrl: './portfolio-dashboard.component.html'
})
export class PortfolioDashboardComponent implements OnInit {
  public club: any;
  public advertisementCount = 0
  public zestCount = 0
  constructor(private apiService: ApiService, private oAuthService: OAuthService, private fireDatabase: AngularFireDatabase, ) {

  }



  async  ngOnInit() {
    this.club = this.oAuthService.getClub()
    await this.getAdvertisement()
    await this.getCourse()
  }

  async getAdvertisement() {
    let promise = new Promise<any>((resolve, reject) => {
      this.apiService.list("advertisements/").then(result => {

        this.advertisementCount = result.length
        resolve(result);
      });

    });
    return promise;
  }

  async getCourse(): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      this.apiService.list("zest-course-mapping/").then(result => {
        console.log(result);
        this.zestCount = result.length
        resolve(result);
      });

    });
    return promise;
  }




}




